// Author liang gang qiang
// Date 2021-10-26 10:27:55

class MintalMesPrdProductionEnergyCost {
constructor({
        id = null,
        prdResultId = '',
        costEnergyId = '',
        quantity = '',
        unit = '',
        remark = ''}
= {}) {
    this.id = id;
    this.prdResultId = prdResultId;
    this.costEnergyId = costEnergyId;
    this.quantity = quantity;
    this.unit = unit;
    this.remark = remark;
}
}

function newEntity() {
return new MintalMesPrdProductionEnergyCost();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.mintal.prd.mintalMesPrdProductionEnergyCost.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'shiftPlanCode',
        label: 'label.mintal.prd.mintalMesPrdProductionEnergyCost.grid.shiftPlanCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'planDay',
        label: 'label.mintal.prd.mintalMesPrdProductionEnergyCost.grid.planDay',
        sortable: true,
        form: {
        type: 'datepicker'
        }
        },
        {
        key: 'locationName',
        label: 'label.mintal.prd.mintalMesPrdProductionEnergyCost.grid.locationName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'shiftName',
        label: 'label.mintal.prd.mintalMesPrdProductionEnergyCost.grid.shiftName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'costEnergyCode',
        label: 'label.mintal.prd.mintalMesPrdProductionEnergyCost.grid.costEnergyCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'costEnergyName',
        label: 'label.mintal.prd.mintalMesPrdProductionEnergyCost.grid.costEnergyName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'quantity',
        label: 'label.mintal.prd.mintalMesPrdProductionEnergyCost.grid.quantity',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'unit',
        label: 'label.mintal.prd.mintalMesPrdProductionEnergyCost.grid.unit',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.mintal.prd.mintalMesPrdProductionEnergyCost.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    prdResultIdFilter : '',
    costEnergyIdFilter : '',
    quantityFilter : '',
    unitFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'prdResultIdFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionEnergyCost.filter.prdResultId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesPrdProductionResult'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'costEnergyIdFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionEnergyCost.filter.costEnergyId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesMstEnergy'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'quantityFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionEnergyCost.filter.quantity',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'unitFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionEnergyCost.filter.unit',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'prdResultId',
        label: 'label.mintal.prd.mintalMesPrdProductionEnergyCost.entity.prdResultId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesPrdProductionResult'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'costEnergyId',
        label: 'label.mintal.prd.mintalMesPrdProductionEnergyCost.entity.costEnergyId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesMstEnergy'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'quantity',
        label: 'label.mintal.prd.mintalMesPrdProductionEnergyCost.entity.quantity',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'unit',
        label: 'label.mintal.prd.mintalMesPrdProductionEnergyCost.entity.unit',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.mintal.prd.mintalMesPrdProductionEnergyCost.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {MintalMesPrdProductionEnergyCost, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
